var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showValue)?_c('div',{staticClass:"flex-column flex-align-center popup-content",on:{"click":function($event){_vm.showValue = false}}},[_c('div',{staticClass:"popup-temp"},[_vm._t("title"),_vm._t("content")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }